var functionality_id = 'SS16';
var functionality_description = 'VENTA TAE - PAGO UNICO';
var isTransmitToken = false;

//se dejara para futuras observaciones
function userDidTapBackButton() {
  if (pathExit()) {
    quitApp();
  } else {
    if (typeof Connect !== "undefined") {
      Connect.goBack();
    } else {
      // //console.log('elkse');
      var params = {
        "name": "goBack",
        "parameters": null,
        "callbackName": null
      };

      var miConnect = window.webkit.messageHandlers.Connect;
      miConnect.postMessage(JSON.stringify(params));
    }
  }
}

function pathExit() {
  const mPath = window.location.pathname;
  const paths = [
    '/captura',
    '/ticket'
  ];
  let exitePath = false;
  paths.forEach((path) => {
    if (path === mPath) {
      exitePath = true;
    }
  });
  return exitePath;
}

function hideBackButton() {
  if (typeof Connect !== "undefined") {
    Connect.hideBackButton();
  } else {
    var params = {
      "name": "hideBackButton",
      "parameters": null,
      "callbackName": null
    };
    var miConnect = window.webkit.messageHandlers.Connect;
    miConnect.postMessage(JSON.stringify(params));
  }
}

function showBackButton() {
  if (typeof Connect !== "undefined") {
    Connect.showBackButton();
  } else {
    var params = {
      "name": "showBackButton",
      "parameters": null,
      "callbackName": null
    };
    if (window.webkit != undefined) {
      var miConnect = window.webkit.messageHandlers.Connect;
      miConnect.postMessage(JSON.stringify(params));
    }
  }
}

function requestToken() {
  isTransmitToken = false;
  getCodeVerifier()
  getCodeChallenge()
  const whatOSIs = getMobileOperatingSystem();
  getToken().then(response => {
    const mToken = whatOSIs == 'Android' ? JSON.parse(response) : response;
    const tokenValue = mToken.token || mToken.csm;
    if (tokenValue) {
      responseToken(tokenValue, isTransmitToken, mToken.date, "");
    }
  })
}

function getTokenDone(code) {
  var obj = JSON.parse(code);
  var tokenString = obj.params.token;
  var tipoOTP = obj.params.tipoOTP;
  var date = obj.params.date;
  var message = obj.params.message;

  if (obj.status == "true") {
    //console.log('token -> ' + obj.params.token);
    window.angularComponentRef.zone.run(
      () => {
        window.angularComponentRef.componentToken(tokenString, tipoOTP, date, "");
      }
    );
  } else {
    //console.log('token -> ' + obj.params.message);
    window.angularComponentRef.zone.run(
      () => {
        window.angularComponentRef.componentToken("", "", "", message);
      }
    );
  }
}

function responseToken(tokenString, tipoOTP, date, message) {
  window.angularComponentRef.zone.run(
    () => {
      window.angularComponentRef.componentToken(tokenString, tipoOTP, date, message);
    }
  );
}


function quitApp() {

  if (typeof Connect !== "undefined") {
    // //console.log('SALIR DE LA APP');
    Connect.goToRoot();
  } else {
    var params = {
      "name": "goToRoot",
      "parameters": null,
      "callbackName": null
    };
    var miConnect = window.webkit.messageHandlers.Connect;
    miConnect.postMessage(JSON.stringify(params));
  }
}

function getSSOToken() {
  if (typeof Connect !== "undefined") {
    try {
      getSSOTokenDoneConnect(Connect.getSSOToken());
    } catch (err) {
      getSSOTokenDoneConnect(null);
    }
  } else {
    var params = {
      "name": "getSSOToken",
      "parameters": null,
      "callbackName": "getSSOTokenDone"
    };
    if (window.webkit != undefined) {
      var miConnect = window.webkit.messageHandlers.Connect;
      miConnect.postMessage(JSON.stringify(params));
    } else {
      window.angularCatalogInit.getSSOTokenDone(null)
    }

  }
}

function getSSOTokenDone(tokenSSO) {
  var obj = JSON.parse(tokenSSO)
  //console.log(obj)
  if (obj.params != null) {
    window.angularCatalogInit.getSSOTokenDone(obj.params.code);
  }
}

/**
 * Funcion para retorno del ssotoken con variable Connect
 * @param {*} tokenSSO
 */
function getSSOTokenDoneConnect(tokenSSO) {

  window.angularCatalogInit.getSSOTokenDone(tokenSSO);
}

function takeScreenshot() {

  if (typeof Connect !== "undefined") {
    try {
      Connect.takeScreenshot();
    } catch (err) {
    }
  } else {
    var params = {
      "name": "takeScreenshot",
      "params": "",
      "callbackName": ""
    };
    var miConnect = window.webkit.messageHandlers.Connect;
    miConnect.postMessage(JSON.stringify(params));
  }
}

function retrieveCards() {
  if (typeof Connect !== "undefined") {
    try {
      Connect.retrieveCards();
    } catch (err) {
      handleCallback('error', null);
    }
  } else {
    try {
      var params = {
        "name": "retrieveCards",
        "params": "",
        "callbackName": ""
      };
      var miConnect = window.webkit.messageHandlers.Connect;
      miConnect.postMessage(JSON.stringify(params));
    } catch (e) {
      handleCallback('error', null);
    }
  }
}

function retrieveContacts() {
  if (typeof Connect !== "undefined") {
    try {
      Connect.retrieveContacts();
    } catch (err) {
      handleCallback('error', null);
    }
  } else {
    try {
      var params = {
        "name": "retrieveContacts",
        "params": "",
        "callbackName": ""
      };
      var miConnect = window.webkit.messageHandlers.Connect;
      miConnect.postMessage(JSON.stringify(params));
    } catch (e) {
      handleCallback('error', null);
    }
  }
}

function obtainCollectData() {
  if (typeof Connect !== "undefined") {
    try {
      Connect.obtainCollectData();
    } catch (err) {
      handleCallback('RSA', null);
    }
  } else {
    try {
      var params = {
        "name": "obtainCollectData",
        "params": "",
        "callbackName": ""
      };
      var miConnect = window.webkit.messageHandlers.Connect;
      miConnect.postMessage(JSON.stringify(params));
    } catch (e) {
      handleCallback('RSA', null);
    }
  }
}

function getBranchData() {
  if (typeof Connect !== "undefined") {
    try {
      Connect.getBranchData();
    } catch (err) {
      handleCallback('BRANCH', null);
    }
  } else {
    try {
      var params = {
        "name": "getBranchData",
        "params": "",
        "callbackName": ""
      };
      var miConnect = window.webkit.messageHandlers.Connect;
      miConnect.postMessage(JSON.stringify(params));
    } catch (e) {
      handleCallback('BRANCH', null);
    }
  }
}

function handleCallback(command, data) {
  try {
    window.angularComponentRef.zone.run(
      () => {
        window.angularComponentRef.loadAngularFunction(command, data);
      }
    );
  } catch (e) {
    console.log(e, 'error handle');
    console.warn('angularComponentRef: ', command, 'not found')
  }
}

function getToken() {
  var codeChallenge = "codeChallenge"
  const currentOS = this.getMobileOperatingSystem();

  switch (currentOS) {
    case 'Android':
      return this.getAndroidToken(codeChallenge, functionality_id, functionality_description);
    case 'iOS':
      // TODO
      return this.getIosToken();
  }
};

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  if (/iPad|iPhone|Macintosh|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  return 'unknown';
}

function getAndroidToken() {
  const isSoftokenActive = window.Connect.isSoftTokenActive();

  if (isSoftokenActive) {
    const currentFeature = 'goPay';
    const isTransmitAllowed = window.Connect.isTransmitAllowed();
    const isFeatureEnabled = getAndroidFttFlag(currentFeature);

    if (isTransmitAllowed && isFeatureEnabled) {
      isTransmitToken = true;
      const codeChallenge = localStorage.getItem("codeChallenge") ?? ''
      return callAndroidTransmitToken(codeChallenge, functionality_id, functionality_description);
    }
  }

  return this.callAndroidLegacyToken();
};

function callAndroidLegacyToken() {
  const TokenManager = window.TokenManager;
  if (TokenManager !== undefined) {
    return TokenManager.getToken();
  }
}

function getAndroidFttFlag(currentFeaure) {
  const fttObject = JSON.parse(window.SuperTokenJSObject.provideFtt());
  const feature = validateFeature(fttObject, currentFeaure);
  return feature.isEnabled;
};

function validateFeature(fttObject, currentFeaure) {
  // Path donde se encuentran las subfeatures de transmit en el FTT de configuración
  const path = `superMovil.modules.transmit.features.${currentFeaure}`
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== 'undefined') ? acc[key] : undefined, fttObject);
};

function callAndroidTransmitToken(codeChallenge) {
  return new Promise(resolve => {
    window.TransmitTokenManager.getSuperToken(codeChallenge, functionality_id, functionality_description, null, true).then(response => resolve(response));
  });
}

async function getIosToken() {
  const isSoftTokenActive = await getSoftTokenStatusiOs();
  const isTransmitAllowed = await iosIsTransmitAllowed();

  if (isSoftTokenActive && isTransmitAllowed) {
    isTransmitToken = true;
    return iosTokenTransmit.toPromise();
  } else if (!isSoftTokenActive && isTransmitAllowed) {
    isTransmitToken = true;
    return iosTokenTransmit.toPromise();
  }

  return iosTokenLegacy();
};

function getCodeVerifier() {
  let codeVerifier = SecureBAAS.SecurityHelper.prototype.generateCodeVerifier();
  localStorage.setItem('codeVerifier', codeVerifier);
}

function getCodeChallenge() {
  let codeChallenge = SecureBAAS.SecurityHelper.prototype.generateCodeChallenge(localStorage.getItem('codeVerifier'));
  localStorage.setItem('codeChallenge', codeChallenge);
}

/*function generateTraceId() {
  let device = encode_deviceprint();
  window.angularComponentReference.setTraceIdHelper( device );
}*/

function goBack() {
  if (typeof Connect !== "undefined") {
    Connect.goBack();
  } else {
    var params = {
      "name": "goBack",
      "parameters": null,
      "callbackName": null
    };
    var miConnect = window.webkit.messageHandlers.Connect;
    miConnect.postMessage(JSON.stringify(params));
  }
}

function callSuperLine() {
  if (typeof Connect !== "undefined") {
    Connect.callSuperLine();
  } else {
    var params = {
      "name": "callSuperLine",
      "parameters": null,
      "callbackName": null
    };
    var miConnect = window.webkit.messageHandlers.Connect;
    miConnect.postMessage(JSON.stringify(params));
  }
}

function requestSuperTokenAndroid(csm_id, phone) {
  return new Promise((resolve, reject) => {
    const transmitAllowed= window.Connect.isTransmitAllowed();
    localStorage.setItem("isTransmit", transmitAllowed);
    if (transmitAllowed) {
      if ( typeof window.TransmitTokenManager !== 'undefined' &&
      typeof window.TransmitTokenManager.getSuperToken === 'function'
      ) {
      window.TransmitTokenManager.getSuperToken(
        localStorage.getItem("codeChallenge"),                     // codeChallenge opcional
        'SS16',                       // functionalityId
        'COMPRA_DE_TIEMPO_AIRE',         // functionalityDescription
        { cuentaDestino: phone },         // additionalData
        true,                                  // isFunctionalityEnabled
        csm_id,                 // CSM_ID de RiskAssessment (opcional)
        localStorage.getItem('codeVerifier')                 // CodeVerifier de RiskAssessment (opcional)
      ).then((tokenString) => {
        const token = JSON.parse(tokenString);
        resolve(token); // token.token, token.typeOTP, token.date, etc.
      }).catch((error) => {
        reject('Error al generar token: ' + error);
      });
    }else{
         reject('TransmitTokenManager no disponible');
         console.log("TransmitTokenManager no disponible")
    }
  }else {
     if (typeof window.TokenManager !== 'undefined' &&
      typeof window.TokenManager.getToken === 'function'
      ){
         window.TokenManager.getToken(
        localStorage.getItem("codeChallenge"),                     // codeChallenge opcional
        'SS16',                       // functionalityId
        'COMPRA_DE_TIEMPO_AIRE',         // functionalityDescription
        { cuentaDestino: phone },         // additionalData
        true,                                  // isFunctionalityEnabled
        csm_id,                 // CSM_ID de RiskAssessment (opcional)
        localStorage.getItem('codeVerifier')                 // CodeVerifier de RiskAssessment (opcional)
      ).then((tokenString) => {
        const token = JSON.parse(tokenString);
        resolve(token); // token.token, token.typeOTP, token.date, etc.
      }).catch((error) => {
        reject('Error al generar token: ' + error);
      });
      }
      else{
        reject('TokenManager no disponible');
         console.log("TokenManager no disponible")
      }
     
    }
  });
}

function iosIsTransmitAllowed() {
  return new Promise((resolve, reject) => {
    var params = {
      "name": "isTransmitAllowed",
      "parameters": null,
      "callbackName": "isTransmitAllowedDone"
    };
    
    // Definir callback global temporal
    window.isTransmitAllowedDone = function(result) {
      try {
        const response = JSON.parse(result);
        resolve(response.params ? response.params : result);
      } catch (err) {
        resolve(result);
      }
    };
    
    var miConnect = window.webkit.messageHandlers.Connect;
    miConnect.postMessage(JSON.stringify(params));
  });
}

function requestSuperTokenIOS(csm_id, phone) {
  return new Promise(async (resolve, reject) => {
    const transmitAllowed = await iosIsTransmitAllowed();
    localStorage.setItem("isTransmit", transmitAllowed);  
    if (
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers !== 'undefined' &&
      typeof window.webkit.messageHandlers.TransmitTokenManager !== 'undefined'
    ) {
      window.webkit.messageHandlers.TransmitTokenManager.postMessage({
        name: 'superTokenTransmit',
        parameters: {
          codeChallenge: localStorage.getItem("codeChallenge"),
          functionalityId: 'SS16',
          functionalityDesc: 'COMPRA_DE_TIEMPO_AIRE',
          isFunctionalityEnabled: true,
          additionalData: {
            cuentaDestino: phone
          },
          csm_id: csm_id,     // requerido si se ejecutó RiskAssessment
          code_verifier: localStorage.getItem('codeVerifier') // requerido si se ejecutó RiskAssessment
        },
        callbackName: 'handleCallback'
      });
      window.handleCallback = (payload) => {
        try {
          const response = JSON.parse(payload);
          if (response.status === 'true') {
            resolve(response.params);
          } else {
            reject('Error nativo: ' + response.params?.message);
          }
        } catch (err) {
          reject('Error procesando respuesta nativa');
        }
      };
    } else {
      reject('TransmitTokenManager no disponible en esta plataforma');
    }
  });
}

function vaildateNewCallbacks() {
  let newExist = false;
  const currentOS = this.getMobileOperatingSystem();
  console.log("Valida nuevos callbacks smconnect")
  switch (currentOS) {
    case "Android":
      newExist = typeof window.TransmitRiskAssessmentManager !== 'undefined' &&
        typeof window.TransmitRiskAssessmentManager.getRiskAssessment === 'function';
      break;
    case "iOS":
      newExist = typeof window.webkit !== 'undefined' &&
        typeof window.webkit.messageHandlers !== 'undefined' &&
        typeof window.webkit.messageHandlers.TransmitTokenManager !== 'undefined';
      break;
  }
  return newExist;
}

function evaluateRiskAssesment(transactionData) {
  console.log("Se ejecuta risk assessment");
  const currentOS = this.getMobileOperatingSystem();
  switch (currentOS) {
    case "Android":
      console.log("SO Android");
      return runRiskAssessmentAndroid(transactionData);
    case "iOS":
      console.log("SO IOS");
      return runRiskAssessmentIOS(transactionData);
  }
}

function runRiskAssessmentAndroid(transactionData) {
  return new Promise((resolve, reject) => {
    if (
      typeof window.TransmitRiskAssessmentManager !== 'undefined' &&
      typeof window.TransmitRiskAssessmentManager.getRiskAssessment === 'function'
    ) {
      //TODO validar archivo de constantes!!
      window.TransmitRiskAssessmentManager.getRiskAssessment(
        'SS16',
        'COMPRA_DE_TIEMPO_AIRE',
        transactionData.amount?transactionData.amount:transactionData._amount, 
        "MXN"
      ).then((resultString) => {
        console.log(resultString);
        const result = JSON.parse(resultString);
        console.log(result);
        resolve(requestSuperTokenAndroid(result.csmid, transactionData.phone));
      }).catch((error) => {
        console.log("Ocurre error ", error);
        reject('Error en evaluación MTU: ' + error);
      });
    } else {
      console.log("Falla validación")
      reject('TransmitTokenManager no disponible');
    }
  });
}

function runRiskAssessmentIOS(transactionData) {
  return new Promise((resolve, reject) => {
    if (
      typeof window.webkit !== 'undefined' &&
      typeof window.webkit.messageHandlers !== 'undefined' &&
      typeof window.webkit.messageHandlers.TransmitTokenManager !== 'undefined'
    ) {
      window.webkit.messageHandlers.TransmitTokenManager.postMessage({
        name: 'runRiskAssessment',
        parameters: {
          functionalityId: 'SS16',
          functionalityDesc: 'COMPRA_DE_TIEMPO_AIRE',
          amount: transactionData.amount?transactionData.amount:transactionData._amount,
          currency: 'MXN'
        },
        callbackName: 'handleCallback'
      });
      window.handleCallback = (payload) => {
        try {
          const response = JSON.parse(payload);
          if (response.status === 'true') {
            resolve(requestSuperTokenIOS(response.params.csmid, transactionData.phone));
          } else {
            reject('Error nativo: ' + response.params?.message);
          }
        } catch (err) {
          console.log("Ocurre error ", error);
          reject('Error procesando respuesta nativa');
        }
      };
    } else {
      console.log("Falla validación")
      reject('TransmitTokenManager no disponible en esta plataforma');
    }
  });
}